import Error from 'components/error/error.component';
import React from 'react';
import { usePreloadComponent } from './preload.hooks';

const Preload = ({ children }) => {
  const { isError, isSuccess, error } = usePreloadComponent();

  if (isError) return <Error error={error} />;

  return isSuccess && children;
};

export default React.memo(Preload);
